module.exports = __webpack_public_path__ + "img/icon-info.e483fbb9.svg";